import {
  type ReferentialEnum,
  referentialEnumToReferentialCodeList,
} from "@pharmupp/p3-front-commons"

const newsFlashStatusesEnum = {
  PUBLISHED: { label: "Publiée", color: "success.main" },
  WAITING: { label: "Attente publication", color: "common.orange" },
  ARCHIVED: { label: "Désactivée", color: "primary.main" },
} as const satisfies ReferentialEnum<{ color: string }>
export const newsFlashStatusesReferential =
  referentialEnumToReferentialCodeList(newsFlashStatusesEnum)
export type NewsFlashStatusesName = keyof typeof newsFlashStatusesEnum
